import { apiUrl } from '../runtime'

// Client-side replacement for the server-only `@/lib/api` in the widget build. Mirrors the
// exact endpoints the server `getX` functions hit, but called from the browser against core's
// backend with the shared session cookie (`credentials: include`). Only the functions the
// widget entry / action shims actually call need to exist here; type-only imports elsewhere
// are erased at build time.

async function getJson<T>(path: string, fallback: T): Promise<T> {
  try {
    const res = await fetch(apiUrl(path), { credentials: 'include', cache: 'no-store' })
    if (!res.ok) return fallback
    return (await res.json()) as T
  } catch {
    return fallback
  }
}

export const getMe = () => getJson<unknown | null>('/api/auth/me', null)
export const getMarkets = () => getJson<unknown[]>('/api/markets', [])
export const getEvents = () => getJson<unknown[]>('/api/events', [])
export const getCategories = () => getJson<string[]>('/api/categories', [])
export const getLeaderboardList = () => getJson('/api/leaderboard/list', { categories: [], boards: [] })
export const getCasinoList = () => getJson('/api/casino/list', { games: [] })
export const getUserList = () => getJson<unknown[]>('/api/users', [])
export const getUsers = () => getJson<unknown[]>('/api/users', [])
export const getUserPreferences = () =>
  getJson('/api/users/me/preferences', { pinned_nav: [], favourite_leaderboards: [], pinned_markets: [] })
